var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { QboTemplate, template } from "@quandis/qbo4.configuration";
import { elementDate, formatDate, getArray, qbocss, QboFetchMixin } from '@quandis/qbo4.ui';
export class QboContact extends QboFetchMixin(QboTemplate) {
    constructor() {
        super(...arguments);
        this.colFourClass = 'qbo-col-4';
        this.colSixClass = 'qbo-col-6';
        this.colThreeClass = 'qbo-col-3';
        this.colTwelveClass = 'qbo-col-12';
        this.contactId = null;
        this.contactLabel = 'Contact';
        this.contactName = 'Contact';
        this.disabled = true;
        this.divSectionHeaderClass = 'qbo-header';
        this.formControlSmallClass = 'qbo-sm';
        this.formLabelSmallClass = 'qbo-sm';
        this.formSelectSmallClass = 'qbo-sm';
        this.jsonData = {};
        this.type = 'search';
        this.uniqueId = `e${Math.random().toString(36).substring(2, 9)}`;
        this.apiEndpoint = new URL("api://qbo/contact");
    }
    static { this.styles = qbocss; }
    async connectedCallback() {
        if (this.type == 'search') {
            if (Object.keys(this.dataset).length > 0)
                this.payload = { ...this.dataset };
        }
        super.connectedCallback();
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        this.shadowRoot?.querySelectorAll('span').forEach(span => {
            if (span instanceof HTMLSpanElement && span.innerText == '')
                span.innerText = '--';
        });
    }
    async paginate(e) {
        if (this.payload == null)
            this.payload = {};
        this.payload['DisplaySize'] = e.detail['display'];
        this.payload['RecordStart'] = e.detail['start'];
        await this.fetchData(this.headers ?? {}, this.payload);
    }
    renderContextMenu(component) {
        return html `<qbo-menu type="context" target="#${this.uniqueId}">
<menu>
    <li>Copy</li>
    <li>Cut</li>
    <li>Paste</li>
    <li>Delete</li>
    <li>Add Label</li>
    <li>Remove Label</li>
</menu>
        </qbo-contextmenu>`;
    }
    search(component) {
        const json = getArray(component.jsonData);
        const count = Number(json?.[0]?.RecordCount) || 25;
        return html `
<div class="row">
    <div class="col table-responsive">
        <table class="qbo-nowrap" data-drop>
            <thead>
                <tr>
                    <th colspan="6">Contact Search${component.renderContextMenu(component)}</th>
                </tr>
                <tr>
                    <th>
                        <qbo-selectable parent="table"></qbo-selectable>
                        <qbo-table-sort></qbo-table-sort>
                    </th>
                    <th data-sort>Contact</th>
                    <th>Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th><qbo-label>Labels</qbo-label></th>
                </tr>
            </thead>
            <tbody id="${component.uniqueId}">
                ${json ? json.map(item => html `
                    <tr data-selectable="${item.ContactID}">
                        <td><input type="checkbox" id="${item.ContactID}"></td>
                        <td><a href="/api/attachment/${item.ContactID}">${item.Contact}</a></td>
                        <td>${item.ContactType}</td>
                        <td>${formatDate(item.CreatedDate)}</td>
                        <td>${item.CreatedPerson}</td>
                        <td data-qbo-label="${item.ContactID}"></td>
                    </tr>
                `) : html `<tr><td colspan="9">No data available</td></tr>`}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6" class="progress-wrapper">${json && json[0] ? html `<qbo-paginate count="${json[0].RecordCount ?? 25}" @change=${(e) => component.paginate(e)}></qbo-paginate>` : html ``}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>`;
    }
    select(component) {
        const json = getArray(component.jsonData);
        return html `<slot>
${json ? json.map(item => html `
<div class="qbo-row">
    <div class="qbo-card qbo-card-left qbo-card-right qbo-card-top">
        <h3 class="title">${component.contactLabel}</h3>
        <div class="qbo-row">
            <div class="qbo-col qbo-col-noborder">
                <div class="qbo-form">
                    <label>${component.contactLabel}</label>
                    <span>${item.Contact}</span>
                </div>
            </div>
            <div class="qbo-col qbo-col-noborder">
                <div class="qbo-form">
                    <label>Template</label>
                    <span>${item.ContactTemplate}</span>
                </div>
            </div>
            <div class="qbo-col qbo-col-noborder">
                <div class="qbo-form">
                    <label>Status</label>
                    <span>${item.Status}</span>
                </div>
            </div>
            <div class="qbo-col qbo-col-noborder">
                <div class="qbo-form">
                    <label>Type</label>
                    <span>${item.ContactType}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="qbo-row">
    <div class="qbo-card qbo-card-left qbo-card-top">
        <h3 class="title">Location</h3>
        <div class="qbo-row">
            <div class="qbo-col qbo-col-noborder">
                <div class="qbo-form">
                    <label>Company</label>
                    <span>${item.Company}</span>
                    <label>Title</label>
                    <span>${item.Title}</span>
                    <label>Address</label>
                    <span>${item.Address}</span>
                    <label>City</label>
                    <span>${item.City}</span>
                    <label>State</label>
                    <span>${item.State}</span>
                    <label>Postal Code</label>
                    <span>${item.PostalCode}</span>
                    <label>Country</label>
                    <span>${item.Country}</span>
                    <label>Latitude</label>
                    <span>${item.Latitude}</span>
                    <label>Longitude</label>
                    <span>${item.Longitude}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="qbo-card qbo-card-top">
        <h3 class="title">Identity</h3>
        <div class="qbo-row">
            <div class="qbo-col qbo-col-noborder">
                <div class="qbo-form">
                    <label>SSN</label>
                    <qbo-ssn .data="${item}"></qbo-ssn>
                    <label>TIN</label>
                    <span>${item.TIN}</span>
                    <label>Nationality</label>
                    <span>${item.Nationality}</span>
                    <label>Spoken Language</label>
                    <span>${item.SpokenLanguage}</span>
                    <label>Birth Date</label>
                    <span>${elementDate(item.BirthDate)}</span>
                    <label>Death Date</label>
                    <span>${elementDate(item.DeathDate)}</span>
                    <label>Valid Start</label>
                    <span>${elementDate(item.ValidStart)}</span>
                    <label>Valid End</label>
                    <span>${elementDate(item.ValidEnd)}</span>
                    <label>Verified Source</label>
                    <span>${item.VerifiedSource}</span>
                    <label>Verified Date</label>
                    <span>${elementDate(item.VerifiedDate)}</span>
                    <label>Verified Confidence</label>
                    <span>${item.VerifiedConfidence}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="qbo-card qbo-card-right qbo-card-top">
        <h3 class="title">SCRA</h3>
        <div class="qbo-row">
            <div class="qbo-col qbo-col-noborder">
                <div class="qbo-form">
                    <label>SCRA Status</label>
                    <span>${item.SCRAStatus}</span>
                    <label>SCRA Status As Of</label>
                    <span>${elementDate(item.SCRAStatusAsOf)}</span>
                    <label>SCRA Start Date</label>
                    <span>${elementDate(item.SCRAStartDate)}</span>
                    <label>SCRA Discharge Date</label>
                    <span>${elementDate(item.SCRADischargeDate)}</span>
                    <label>SCRA Verified</label>
                    <span>${item.SCRAVerified}</span>
                    <label>SCRA Verified Date</label>
                    <span>${elementDate(item.SCRAVerifiedDate)}</span>
                    <label>SCRA Source</label>
                    <span>${item.SCRASource}</span>
                    <label>SCRA ID</label>
                    <span>${item.SCRAID}</span>
                </div>
            </div>
        </div>
    </div>
</div>
        `) : html `No data available`}
        </slot>`;
        //if (json == undefined || json.Root == undefined || (json.Root.ContactItem == undefined && component.contactId != null)) return html`<p>Loading...</p>`;
        //return html`<slot>
        //    <div class="${component.colSixClass}">
        //        <label for="${component.contactName}" class="${component.formLabelSmallClass}">${component.contactLabel}</label>
        //        <qbo-contact-name class="${component.formControlSmallClass}" name="${component.contactName}" .data="${json.Root.ContactItem}"></qbo-contact-name>
        //    </div>
        //    <div class="${component.colSixClass}">
        //        <label for="ContactTemplateID" class="${component.formLabelSmallClass}">Template</label>
        //        <qbo-select ?disabled=${component.disabled} class="${component.formSelectSmallClass}" name="ContactTemplateID" apiEndpoint="api://qbo/contacttemplate/listwhere?appliesto=${json.Root.ContactItem?.Object}" defaultValue="${json.Root.ContactItem?.ContactTemplateID}"></qbo-select>
        //    </div>
        //    <div class="${component.colSixClass}">
        //        <label for="Status" class="${component.formLabelSmallClass}">Status</label>
        //        <qbo-select ?disabled=${component.disabled} class="${component.formSelectSmallClass}" name="Status" apiEndpoint="api://qbo/objectstatus/customlist?object=Contact&objectid=${json.Root.ContactItem?.ContactTemplateID}" optionValue="ObjectStatus" defaultValue="${json.Root.ContactItem?.Status}"></qbo-select>
        //    </div>
        //    <div class="${component.colSixClass}">
        //        <label for="ContactType" class="${component.formLabelSmallClass}">Type</label>
        //        <qbo-select ?disabled=${component.disabled} class="${component.formSelectSmallClass}" name="ContactType" apiEndpoint="api://qbo/objecttype/customlist?object=Contact&objectid=${json.Root.ContactItem?.ContactTemplateID}" optionValue="ObjectType" defaultValue="${json.Root.ContactItem?.ContactType}"></qbo-select>
        //    </div>
        //    <div class="${component.divSectionHeaderClass}">
        //        <h5>Location</h5>
        //    </div>
        //    <div class="${component.colSixClass}">
        //        <label for="Company" class="${component.formLabelSmallClass}">Company</label>
        //        <input type="text" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="Company" value="${json.Root.ContactItem?.Company}"/>
        //    </div>
        //    <div class="${component.colSixClass}">
        //        <label for="Title" class="${component.formLabelSmallClass}">Title</label>
        //        <input type="text" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="Title" value="${json.Root.ContactItem?.Title}"/>
        //    </div>
        //    <div class="${component.colTwelveClass}">
        //        <label for="Address" class="${component.formLabelSmallClass}">Address</label>
        //        <textarea ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="Address">${json.Root.ContactItem?.Address}</textarea>
        //    </div>
        //    <div class="${component.colSixClass}">
        //        <label for="City" class="${component.formLabelSmallClass}">City</label>
        //        <input type="text" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="City" value="${json.Root.ContactItem?.City}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="State" class="${component.formLabelSmallClass}">State</label>
        //        <qbo-select ?disabled=${component.disabled} class="${component.formSelectSmallClass}" name="State" apiEndpoint="api://qbo/state/list" optionValue="State" defaultValue="${json.Root.ContactItem?.State}"></qbo-select>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="PostalCode" class="${component.formLabelSmallClass}">Postal Code</label>
        //        <input type="text" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="PostalCode" pattern="\d{5}-?(\d{4})?" value="${json.Root.ContactItem?.PostalCode}"/>
        //    </div>
        //    <div class="${component.colSixClass}">
        //        <label for="Country" class="${component.formLabelSmallClass}">Country</label>
        //        <input type="text" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="Country" value="${json.Root.ContactItem?.Country}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="Latitude" class="${component.formLabelSmallClass}">Latitude</label>
        //        <input type="number" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="Latitude" value="${json.Root.ContactItem?.Latitude}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="Longitude" class="${component.formLabelSmallClass}">Longitude</label>
        //        <input type="number" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="Longitude" value="${json.Root.ContactItem?.Longitude}"/>
        //    </div>
        //    <div class="${component.divSectionHeaderClass}">
        //        <h5>Identity</h5>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="USSSN" class="${component.formLabelSmallClass}">SSN</label>
        //        <qbo-ssn .data="${json.Root.ContactItem}"></qbo-ssn>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="TIN" class="${component.formLabelSmallClass}">TIN</label>
        //        <input type="number" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="TIN" value="${json.Root.ContactItem?.TIN}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="Nationality" class="${component.formLabelSmallClass}">Nationality</label>
        //        <qbo-select ?disabled=${component.disabled} class="${component.formSelectSmallClass}" name="Nationality" apiEndpoint="api://qbo/objecttype/list?object=Contact.Nationality" optionValue="ObjectType" defaultValue="${json.Root.ContactItem?.Nationality}"></qbo-select>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SpokenLanguage" class="${component.formLabelSmallClass}">Spoken Language</label>
        //        <qbo-select ?disabled=${component.disabled} class="${component.formSelectSmallClass}" name="SpokenLanguage" apiEndpoint="api://qbo/objecttype/list?object=Contact.SpokenLanguage" optionValue="ObjectType" defaultValue="${json.Root.ContactItem?.SpokenLanguage}"></qbo-select>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="BirthDate" class="${component.formLabelSmallClass}">Birth Date</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="BirthDate" value="${elementDate(json.Root.ContactItem?.BirthDate)}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="DeathDate" class="${component.formLabelSmallClass}">Death Date</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="DeathDate" value="${elementDate(json.Root.ContactItem?.DeathDate)}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="ValidStart" class="${component.formLabelSmallClass}">Valid Start</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="ValidStart" value="${elementDate(json.Root.ContactItem?.ValidStart)}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="ValidEnd" class="${component.formLabelSmallClass}">Valid End</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="ValidEnd" value="${elementDate(json.Root.ContactItem?.ValidEnd)}"/>
        //    </div>
        //    <div class="${component.colSixClass}">
        //        <label for="VerifiedSource" class="${component.formLabelSmallClass}">Verified Source</label>
        //        <input type="text" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="VerifiedSource" value="${json.Root.ContactItem?.VerifiedSource}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="VerifiedDate" class="${component.formLabelSmallClass}">Verified Date</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="VerifiedDate" value="${elementDate(json.Root.ContactItem?.VerifiedDate)}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="VerifiedConfidence" class="${component.formLabelSmallClass}">Verified Confidence</label>
        //        <input type="number" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="VerifiedConfidence" value="${json.Root.ContactItem?.VerifiedConfidence}"/>
        //    </div>
        //    <div class="${component.divSectionHeaderClass}">
        //        <h5>SCRA</h5>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SCRAStatus" class="${component.formLabelSmallClass}">SCRA Status</label>
        //        <qbo-select ?disabled=${component.disabled} class="${component.formSelectSmallClass}" name="SCRAStatus" apiEndpoint="api://qbo/objecttype/list?object=Contact.SCRAStatus" optionValue="ObjectType" defaultValue="${json.Root.ContactItem?.SCRAStatus}"></qbo-select>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SCRAStatusAsOf" class="${component.formLabelSmallClass}">SCRA Status As Of</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="SCRAStatusAsOf" value="${elementDate(json.Root.ContactItem?.SCRAStatusAsOf)}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SCRAStartDate" class="${component.formLabelSmallClass}">SCRA Start Date</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="SCRAStartDate" value="${elementDate(json.Root.ContactItem?.SCRAStartDate)}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SCRADischargeDate" class="${component.formLabelSmallClass}">SCRA Discharge Date</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="SCRADischargeDate" value="${elementDate(json.Root.ContactItem?.SCRADischargeDate)}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SCRAVerified" class="${component.formLabelSmallClass}">SCRA Verified</label>
        //        <input type="text" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="SCRAVerified" value="${json.Root.ContactItem?.SCRAVerified}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SCRAVerifiedDate" class="${component.formLabelSmallClass}">SCRA Verified Date</label>
        //        <input type="date" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="SCRAVerifiedDate" value="${elementDate(json.Root.ContactItem?.SCRAVerifiedDate)}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SCRASource" class="${component.formLabelSmallClass}">SCRA Source</label>
        //        <input type="text" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="SCRASource" value="${json.Root.ContactItem?.SCRASource}"/>
        //    </div>
        //    <div class="${component.colThreeClass}">
        //        <label for="SCRAID" class="${component.formLabelSmallClass}">SCRA ID</label>
        //        <input type="number" ?disabled=${component.disabled} class="${component.formControlSmallClass}" name="SCRAID" value="${json.Root.ContactItem?.SCRAID}"/>
        //    </div>
        //    <qbo-form-edit .data="${json.Root.ContactItem}"></qbo-form-edit>
        //</slot>`;
    }
}
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "colFourClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "colSixClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "colThreeClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "colTwelveClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "contactId", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "contactLabel", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "contactName", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboContact.prototype, "disabled", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "divSectionHeaderClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "formControlSmallClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "formLabelSmallClass", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "formSelectSmallClass", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboContact.prototype, "jsonData", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboContact.prototype, "type", void 0);
__decorate([
    property({ type: URL }),
    __metadata("design:type", Object)
], QboContact.prototype, "apiEndpoint", void 0);
__decorate([
    template('contextmenu'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboContact]),
    __metadata("design:returntype", void 0)
], QboContact.prototype, "renderContextMenu", null);
__decorate([
    template('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboContact]),
    __metadata("design:returntype", void 0)
], QboContact.prototype, "search", null);
__decorate([
    template('select'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboContact]),
    __metadata("design:returntype", void 0)
], QboContact.prototype, "select", null);
if (!customElements.get('qbo-contact'))
    customElements.define('qbo-contact', QboContact);
